<template>
<div>
  <!-- 수집 설정 목록 -->
  <el-row class="mr-b25" style="height: calc(100% - 237px);">
    <div class="title-h4 title-bar tit">[{{rscGetdatTypeName}}] 수집 설정 관리</div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="setting-addel mr-r4">
        <el-button @click="clickAddButton"><i class="far fa-plus" /></el-button>
        <el-button @click="clickDeleteButton" :disabled="selectedRow==null"><i class="far fa-minus" /></el-button>
      </div>
      <w-header-search-button type="mini" @click="setSearchToolVisible"></w-header-search-button>
    </el-row>
    <el-table-wrapper style="height:calc(100% - 67px);" :fit-height="true" :data="rscGetdataSourceTableData" :columns="rscGetdataSourceTableColumns" :column-default="columnDefault" ref="rscGetdataSourceTable" @row-click="clickRow" highlight-current-row :pagination="false"
      :show-search-tool="showSearchTool" row-class-name="c-pointer" :show-custom-header="true">
    </el-table-wrapper>
  </el-row>
  <!-- 수집 설정 상세 정보 -->
  <el-row>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r15">수집설정 상세정보</div>
        <el-button type="primary" v-show="!addFlag" @click="clickMappingKeySettingButton">설정키 관리</el-button>
      </div>
      <div>
        <el-button type="primary" :disabled="!modified" @click="onSaveButtonClick">저장</el-button>
        <el-button :disabled="!modified" @click="onCancelButtonClick">취소</el-button>
      </div>
    </el-row>
    <hr/>
    <el-form label-position="top" :model="rscGetdataSourceFormData" ref="rscGetdataSourceForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="수집설정 ID" prop="sourceId">
            <el-input ref="idField" v-model="rscGetdataSourceFormData.sourceId" :disabled="!addFlag"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="수집설정명" prop="sourceName">
            <el-input ref="nameField" v-model="rscGetdataSourceFormData.sourceName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item prop="sourceData">
          <span slot="label">
            <span>수집설정 값</span>
          <el-popover placement="right" trigger="click" width="400" title="" :offset="40" @show="onShowMappingKeyLegend">
            <div>
              <el-row class="title-bar">
                <div class="title-h4">설정키 목록</div>
              </el-row>
              <el-table-wrapper ref="mappingKeyTable" max-height="400" :data="mappingKeyTableData" :columns="mappingKeyTableColumns" :column-default="columnDefault" :show-search-tool="false" :show-custom-header="true" :pagination="false">
              </el-table-wrapper>
            </div>
            <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
          </el-popover>
          </span>
          <el-input v-model="rscGetdataSourceFormData.sourceData" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </el-row>
  <w-mapping-key-setting-popup ref="mappingKeySettingPopup" :selected-rsc-getdata-source="selectedRow" :selected-mapping-key-list="mappingKeyTableData" @re-load="getMappingKeyRscGetdataList" :sliding-popup-type="slidingPopupType" />
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import RscAPI from '@/api/model/rsc';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WMappingKeySettingPopup from './MappingKeySettingPopup';

export default {
  name: 'WRscGetdataSourceSetting',
  components: {
    WMappingKeySettingPopup,
  },
  props: {
    slidingPopupType: String,
    selectedRscGetdataType: Object,
  },
  data() {
    return {
      showSearchTool: false,
      selectedRow: null,
      addFlag: false,
      modified: false,
      columnDefault,
      rscGetdataSourceTableData: [],
      rscGetdataSourceTableColumns: [
        {
          prop: 'sourceId',
          label: '수집설정 ID',
          searchable: true,
          width: 90,
        },
        {
          prop: 'sourceName',
          label: '수집설정명',
          searchable: true,
          width: 90,
        },
        {
          prop: 'sourceData',
          label: '수집설정 값',
          searchable: true,
        },
      ],
      mappingKeyTableData: [],
      mappingKeyTableColumns: [
        {
          prop: 'mappingKey',
          label: '설정 키',
          searchable: true,
          width: 150,
        },
        {
          prop: 'mappingKeyName',
          label: '설정 키 명',
          searchable: true,
          width: 90,
        },
        {
          prop: 'mappingKeyDesc',
          label: '설명',
          searchable: true,
        },
      ],
      rules: {
        sourceId: {
          required: true,
          validator: this.validateSourceId,
          trigger: 'blur',
        },
        sourceName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        sourceData: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      rscGetdataSourceFormData: {
        sourceId: null,
        sourceName: null,
        sourceData: null,
      },
      originalFormData: null,
    };
  },
  computed: {
    rscGetdatTypeName() {
      return this.selectedRscGetdataType ? getValueAfterCheckEmpty(this.selectedRscGetdataType.rscGetdataTypeName) : EMPTY_TEXT;
    },
  },
  watch: {
    selectedRscGetdataType: {
      handler(object) {
        if (!isNil(object)) {
          this.loadData();
        }
      },
    },
    addFlag: {
      handler(value) {
        if (value) {
          this.rscGetdataSourceFormData = this.createNewSourceData();
          this.originalFormData = clone(this.rscGetdataSourceFormData);
          this.mappingKeyTableData = [];
          this.modified = false;
        }
      },
    },
    selectedRow: {
      handler(object) {
        if (!isNil(object)) {
          this.rscGetdataSourceFormData = clone(object);
          this.originalFormData = clone(this.rscGetdataSourceFormData);
          this.modified = false;
        }
      },
    },
    rscGetdataSourceFormData: {
      deep: true,
      handler(value) {
        this.modified = !isEqual(this.originalFormData, value);
      },
    },
  },
  methods: {
    loadData() {
      RscAPI.getRscGetdataSourceList(this.selectedRscGetdataType.rscGetmethodId, this.selectedRscGetdataType.rscGetdataTypeId).then((response) => {
        if (response.data.success) {
          this.rscGetdataSourceTableData = response.data.data;
          if (!isEmpty(this.rscGetdataSourceTableData)) {
            let selectedRow = null;
            if (isNil(this.selectedRow)) {
              selectedRow = this.rscGetdataSourceTableData[0];
            } else {
              selectedRow = this.rscGetdataSourceTableData.find((object) => object.sourceId === this.selectedRow.sourceId);
              selectedRow = isNil(selectedRow) ? this.rscGetdataSourceTableData[0] : selectedRow;
            }
            this.clickRow(selectedRow);
            this.$nextTick(() => {
              this.$refs.rscGetdataSourceTable.$children[0].setCurrentRow(selectedRow);
              this.$refs.rscGetdataSourceForm.clearValidate();
            });
          } else {
            this.selectedRow = null;
            this.clickAddButton();
          }
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickAddButton() {
      this.addFlag = true;
      this.getMappingKeyRscGetdataList();
      this.$nextTick(() => {
        this.$refs.idField.focus();
      });
    },
    createNewSourceData() {
      return {
        sourceId: null,
        sourceName: null,
        sourceData: null,
      };
    },
    clickRow(row) {
      this.addFlag = false;
      this.selectedRow = clone(row);
      this.getMappingKeyRscGetdataList();
    },
    clickDeleteButton() {
      const rscGetmethodId = this.selectedRow.rscGetmethodId;
      const rscGetdataTypeId = this.selectedRow.rscGetdataTypeId;
      const sourceId = this.selectedRow.sourceId;
      const params = {
        rscGetmethodId,
        rscGetdataTypeId,
        sourceId,
      };
      RuleSettingsAPI.checkRscGetmethodInfoInUse(params).then((response) => {
        const target = '수집설정';
        const action = msgUtil.action.DELETE;
        if (response.data.success) {
          if (response.data.data) {
            this.$message(msgUtil.getCustomMsgData('현재 사용 중인 수집설정은 삭제할 수 없습니다.'));
          } else {
            this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
              RuleSettingsAPI.deleteRscGetdataSource(params)
                .then((deleteResponse) => {
                  if (deleteResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            });
          }
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      });
    },
    getMappingKeyRscGetdataList() {
      if (this.addFlag) {
        RuleSettingsAPI.getMappingKeyList().then((response) => {
          if (response.data.success) {
            this.mappingKeyTableData = response.data.data;
          }
        });
      } else {
        const params = {
          rscGetmethodId: this.selectedRow.rscGetmethodId,
          rscGetdataTypeId: this.selectedRow.rscGetdataTypeId,
          sourceId: this.selectedRow.sourceId,
        };
        RuleSettingsAPI.getMappingKeyRscGetdataList(params).then((response) => {
          if (response.data.success) {
            this.mappingKeyTableData = response.data.data;
          }
        });
      }
    },
    onSaveButtonClick() {
      this.$refs.rscGetdataSourceForm
        .validate()
        .then((response) => {
          const params = clone(this.rscGetdataSourceFormData);
          params.rscGetmethodId = this.selectedRscGetdataType.rscGetmethodId;
          params.rscGetdataTypeId = this.selectedRscGetdataType.rscGetdataTypeId;

          const target = '수집설정';
          if (response) {
            if (this.addFlag) {
              params.mappingKeyList = this.getMappingKeyFromSourceData([], params.sourceData);
              const action = msgUtil.action.ADD;
              RuleSettingsAPI.insertRscGetdataSource(params)
                .then((saveResponse) => {
                  if (saveResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            } else {
              const action = msgUtil.action.SAVE;
              RuleSettingsAPI.updateRscGetdataSource(params)
                .then((saveResponse) => {
                  if (saveResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            }
          }
        })
        .catch(() => {});
    },
    onCancelButtonClick() {
      this.rscGetdataSourceFormData = clone(this.originalFormData);
      if (this.addFlag) {
        this.$refs.idField.focus();
      } else {
        this.$refs.nameField.focus();
      }
    },
    validateSourceId(rule, value, callback) {
      if (!this.addFlag) {
        callback();
      }
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        RuleSettingsAPI.checkRscGetdataSourceIdValidation({
          rscGetmethodId: this.selectedRscGetdataType.rscGetmethodId,
          rscGetdataTypeId: this.selectedRscGetdataType.rscGetdataTypeId,
          sourceId: value,
        }).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 ID입니다.'));
          }
        });
      }
    },
    clickMappingKeySettingButton() {
      this.$refs.mappingKeySettingPopup.$refs.slidingPopup.visible = true;
    },
    clear() {
      this.selectedRow = null;
      this.addFlag = false;
      this.modified = false;
      this.rscGetdataSourceFormData = this.createNewSourceData();
      this.$refs.rscGetdataSourceForm.clearValidate();
    },
    onShowMappingKeyLegend() {
      this.$nextTick(() => {
        this.$refs.mappingKeyTable.getTable().updateScrollY();
      });
    },
    /*
     * 소스 데이터에서 수집 설정 키를 추출해 수집 설정 키 리스트를 반환한다.
     *
     * @author Ju
     * @param  {Object} mappingKeyList 추출할 수집 설정 키를 추가할 리스트
     * @param  {String} sourceData 수집 설정 키를 추출할 소스 데이터
     *
     * @return {Object} mappingKeyList 추출한 수집 설정 키 리스트
     */
    getMappingKeyFromSourceData(mappingKeyList, sourceData) {
      if (!isEmpty(sourceData)) {
        const startIdx = sourceData.indexOf('%');
        let endIdx = startIdx >= 0 ? sourceData.slice(startIdx + 1).indexOf('%') : -1;

        if (startIdx >= 0 && endIdx >= 0) {
          endIdx = startIdx + endIdx + 2;
          const mappingKey = sourceData.slice(startIdx, endIdx);
          mappingKeyList.push(mappingKey);
        } else {
          endIdx = sourceData.length;
        }

        if (sourceData.length <= endIdx) {
          return mappingKeyList;
        }
        return this.getMappingKeyFromSourceData(mappingKeyList, sourceData.substring(endIdx));
      }

      return mappingKeyList;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/RscGetdataSourceSetting.vue